import type { ToolTestResult } from '../../lib/api';
import { TOOL_ERROR_COPY, type ToolErrorCopy } from './tool-test-errors';
import styles from './ToolTestResult.module.css';

type EngineError = Extract<ToolTestResult, { error: string }>;

export const ToolTestErrorCard = ({ error }: { error: EngineError }) => {
  // Defensive: the API could return a code we have no copy for, so treat the lookup as nullable.
  const copy: ToolErrorCopy | undefined = TOOL_ERROR_COPY[error.error];

  return (
    <section className={styles.card}>
      <header className={styles.cardHeader}>
        <span className={styles.errorBadge}>{error.error}</span>
      </header>
      <h4 className={styles.errorTitle}>{copy?.title ?? 'Error'}</h4>
      {copy?.hint && <p className={styles.errorHint}>{copy.hint}</p>}
      {error.message && <p className={styles.errorMessage}>{error.message}</p>}
      {error.requiredScope && <p className={styles.errorMeta}>Required scope: {error.requiredScope}</p>}
      {error.fields && error.fields.length > 0 && (
        <ul className={styles.fieldList}>
          {error.fields.map(field => (
            <li key={field}>{field}</li>
          ))}
        </ul>
      )}
    </section>
  );
};
